import React, { useState } from 'react';
import { Input } from 'antd';
// var Input = require('antd/lib/input');
// require('antd/lib/input/style');

// 由于 antd 组件的默认文案是英文，所以需要修改为中文

function Name(x) {
  let tmp;
  if (x<=30) {
    let y = x - parseInt(x/10) - 1;
    if (x%10!==0)
      tmp = <span>{String.fromCharCode(55356,56320+7+y)}</span>;
    else {
      y = y + 5;
      tmp = <span style={{"color":"red"}}>{String.fromCharCode(55356,56320+7+y)}</span>;
    }
  }
  else {
    const magic = [0,1,2,3,6,5,4];
    let y = magic[x - 30 - 1];
    tmp = <span>{String.fromCharCode(55356,56320+y)}</span>;
  }
  return tmp;
}

const Gao = () => {
  const [str,setStr] = useState("unknown expression")
  const onChange = value => {
    const t = value.target.value;
    var tmp;
    var pat = /^([0-9]+[msp]|[1-7]+z)+$/;
    if (!pat.test(t)) {
      tmp = "unknown expression";
    }
    else {
      var x = [];
      var now = null;
      console.log(x);
      for (let i=t.length-1;i>=0;i--) {
        if (t[i] === "m") {
          now = 0;
        }
        else if (t[i] === "s") {
          now = 1;
        }
        else if (t[i] === "p") {
          now = 2;
        }
        else if (t[i] === "z") {
          now = 3;
        }
        else {
          x.push(now*10+(t[i]-'0'));
        }
      }
      x.sort( (a,b)=>{return a-b;} );
      tmp = [];
      for (let i=0;i<x.length;i++)
        tmp[i]=Name(x[i]);
    }
    setStr(tmp);
  };
  return (
    <div style={{ width: 400, margin: '100px auto' }}>
      <Input placeholder="input" onChange={onChange} />
      <div style={{ "fontSize": "30px" }}>
        {str}
      </div>
    </div>
  );
}

export default Gao;